import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class BankIdBanksService extends ApiService<any> {
    // @API bankid/banks
    protected serviceName = 'bankid/banks';

    constructor() {
        super();
        this.initConnection();
    }
}
